import { Briefcase, FileSearch, FileCheck2, HardDrive } from "lucide-react";
import { fmtBytes } from "@/lib/api";

export default function StatsStrip({ stats }) {
  const s = stats || {};
  const items = [
    { key: "cases", label: "Cases crawled", value: s.cases ?? "—", icon: Briefcase },
    { key: "found", label: "PDFs found", value: s.found ?? "—", icon: FileSearch },
    { key: "downloaded", label: "PDFs zipped", value: s.downloaded ?? "—", icon: FileCheck2 },
    { key: "bytes", label: "Total downloaded", value: stats ? fmtBytes(s.bytes) : "—", icon: HardDrive },
  ];
  return (
    <section className="grid grid-cols-2 lg:grid-cols-4 border border-slate-200 rounded-lg bg-white divide-x divide-y lg:divide-y-0 divide-slate-200 overflow-hidden" data-testid="stats-strip">
      {items.map((it) => (
        <div key={it.key} className="p-5 sm:p-6" data-testid={`stat-${it.key}`}>
          <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-slate-500">
            <it.icon size={14} /> {it.label}
          </div>
          <div className="font-heading text-3xl font-bold mt-2 tabular-nums">{it.value}</div>
        </div>
      ))}
    </section>
  );
}
